import React, { useEffect } from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import FormTextField from "../../../components/textField/formTextField";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addOrUpdateInternationalSuppliers,
  callApiAsync
} from "../../../services/apiService";
import { canManageInternationalSuppliers } from "../../../constants/supplierRoles";

const CreateInternationalSuppliers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state?.data;

  const validationSchema = yup.object().shape({
    supplier_name: yup.string().required("Nombre requerido"),
    supplier_id: yup.string().required("ID requerido"),
    address: yup.string().required("Dirección requerida"),
    country: yup.string().required("País requerido"),
    city: yup.string().required("Ciudad requerida"),
    contact_name: yup.string().required("Nombre de contacto requerido"),
    phone: yup.string().required("Teléfono requerido"),
    email: yup.string().email("Correo inválido").required("Correo requerido"),
    financial_statement_url: yup.string().required("URL requerida")
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onSubmit"
  });

  const userData = useSelector((state) => state.userData.userData);
  const isSupplierManagment = canManageInternationalSuppliers(userData.roleList);

  const setValues = (data) => {
    setValue("supplier_name", data.supplier_name || "");
    setValue("supplier_id", data.supplier_id || "");
    setValue("address", data.address || "");
    setValue("country", data.country || "");
    setValue("city", data.city || "");
    setValue("contact_name", data.contact_name || "");
    setValue("phone", data.phone || "");
    setValue("email", data.email || "");
    setValue("financial_statement_url", data.financial_statement_url || "");
  };

  const onSubmit = async (data) => {
    const payload = {
      id: rowData ? rowData.id : 0,
      ...data,
      creator_user_id: userData.id
    };

    await callApiAsync(
      () => addOrUpdateInternationalSuppliers(payload),
      () => {
        navigate("/suppliers/international_suppliers");
      }
    );
  };

  useEffect(() => {
    if (rowData && rowData.id !== 0) {
      setValues(rowData);
    }
  }, [rowData]);

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle">
        <h1>
          {rowData?.id === 0 ? "CREAR NUEVO" : "EDITAR"} PROVEEDOR FARMACÉUTICO
          INTERNACIONAL
        </h1>
      </div>
      <div className="table-container">
        <h1 className="title-bio-details-chard vm-20">
          Proveedor Farmacéutico Internacional
        </h1>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nombre del Proveedor:</p>
            <FormTextField
              name="supplier_name"
              control={control}
              error={errors.supplier_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">ID:</p>
            <FormTextField
              name="supplier_id"
              control={control}
              error={errors.supplier_id}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Dirección Principal:</p>
            <FormTextField
              name="address"
              control={control}
              error={errors.address}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Ciudad*:</p>
            <FormTextField
              name="city"
              control={control}
              error={errors.city}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">País de Procedencia:</p>
            <FormTextField
              name="country"
              control={control}
              error={errors.country}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Nombre de Contacto*:</p>
            <FormTextField
              name="contact_name"
              control={control}
              error={errors.contact_name}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Teléfono*:</p>
            <FormTextField
              name="phone"
              control={control}
              error={errors.phone}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <p className="create-label ml-0">Correo Electrónico*:</p>
            <FormTextField
              name="email"
              control={control}
              error={errors.email}
              margin="0"
              disabled={!isSupplierManagment}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <p className="create-label ml-0">Link Estado Financiero*:</p>
          <FormTextField
            name="financial_statement_url"
            control={control}
            error={errors.financial_statement_url}
            margin="0"
            disabled={!isSupplierManagment}
          />
        </Grid>
        <br />
        {isSupplierManagment && (
          <div className="HContainer j-center w-complete">
            <LaddaButton
              variant="contained"
              onClick={(e) => handleSubmit(onSubmit)(e)}
            >
              <div className="HContainer align-center">
                <p className="button_text">
                  {rowData?.id === 0 ? "Crear" : "Editar"} Proveedor
                  Farmacéutico Internacional
                </p>
              </div>
            </LaddaButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateInternationalSuppliers;
